import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, List, Button, Modal, InputItem, Toast, Badge, ActionSheet } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import { createForm } from 'rc-form';
import CommonUtils from '../utils/CommonUtils';
import '../styles/PacketPage.css';

const history = require("history").createHashHistory()
const alert = Modal.alert

class PacketPage extends Component {
    static defaultProps = {
        fetchSites: (params, callback) => {},
        fetchPackets: (params, callback) => {},
        fetchDeviceTypes: (params, callback) => {},
        createPacket: (params, callback, completed) => {},
        updatePacket: (params, callback, completed) => {},
        deletePacket: (params, callback) => {},
        delegateProfile: (params, callback) => {}
    }

    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            selectedItem: null,
            sites: [],
            selectedSite: '',
            deviceType: '',
            delegateProfile: null,
            deviceTypes: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 135;
        this.setState({
            height
        })

        this.props.delegateProfile({}, (resp) => {
            this.setState({
                delegateProfile: resp.data
            })
        })

        this.loadSites(() => {
            this.loadPageData(1, height)
        })

        this.loadDeviceTypes()
    }

    loadSites = (callback) => {
        this.props.fetchSites({}, (resp) => {
            this.setState({
                sites: resp.data,
                selectedSite: resp.data[0]?resp.data[0].id:null
            }, () => {
                callback&&callback()
            })
        })
    }

    loadDeviceTypes = () => {
        this.props.fetchDeviceTypes({}, (resp) => {
            this.setState({
                deviceTypes: resp.data
            })
        })
    }

    loadPageData = (pageNum) => {
        const { selectedSite, deviceType } = this.state

        const params = {
            pageNum,
            pageSize: 10,
            siteId: selectedSite,
            deviceType
        }

        this.props.fetchPackets(
            params, 
            (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        )
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onSitePickerChange = (val) => {
        this.setState({
            selectedSite: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    onDeviceTypePickerChange = (val) => {
        this.setState({
            deviceType: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    handleItemClick = (rowData) => {
        const { delegateProfile } = this.state
        const options = []
        if(!delegateProfile || delegateProfile.delegateType === 'OPERATOR') {
            options.push({ icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' })
            options.push({ icon: <i className='iconfont icon-shanchu1' style={{color:'red', fontSize: 30}}/>, title: '删除套餐' })
        }
        if(!options.length) {
            Toast.info('无操作权限')
            return
        }

        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.name?rowData.name:`${rowData.gameMinutes}分钟套餐`,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '删除套餐') {
                this.handleDeleteClick(rowData)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleCreateClick = () => {
        const { selectedSite } = this.state
        if(!selectedSite) return

        this.setState({
            enableCreate: true
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('create_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableCreate: true
                        })
                        return
                    }
                }
            }

            const params = {
                siteId: selectedSite
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('create_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('create_'.length)] = propValue               
            }

            this.props.createPacket(
                params, 
                (resp) => {
                    this.setState({
                        showCreateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                () => {
                    this.setState({
                        enableCreate: true
                    })
                }
            )
        })
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('update_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            const params = {
                id: selectedItem.id
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_') !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring('update_'.length)] = propValue
            }

            this.props.updatePacket(
                params,
                (resp) => {
                    this.setState({
                        showUpdateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                () => {
                    this.setState({
                        enableUpdate: true
                    })
                }
            )
        })
    }

    handleDeleteClick = (rowData) => {
        let packetName = rowData.name ? rowData.name : `${rowData.gameMinutes}分钟套餐`
        alert('确认要删除套餐?', packetName, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                this.props.deletePacket(
                    {id: rowData.id},
                    (resp) => {
                        Toast.info('套餐已删除')
                        this.loadPageData(1)
                    }
                )
            }},
          ])
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        let tagBadge = (<Badge text={rowData.label} style={{backgroundColor: '#04bbc5'}}/>)
        let name = rowData.name ? rowData.name : `${rowData.gameMinutes}分钟套餐`
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{name}</span>}
                            extra={tagBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>设备类型：</span> 
                                    <span>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>游戏时间：</span> 
                                    <span>{rowData.gameMinutes} 分钟</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>会&nbsp;&nbsp;员&nbsp;&nbsp;价：</span> 
                                    <span>￥{rowData.price}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span>新用户价：</span> 
                                    <span>{rowData.fresherPrice?`￥${rowData.fresherPrice}`:'无'}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span>套餐描述：</span> 
                                    <span>{rowData.description}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span></span> 
                                    <span></span>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate, deviceTypes } = this.state
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>新建套餐</div>}>
                        <Picker
                            cols={1}
                            data={deviceTypePickerData}
                            {...getFieldProps('create_deviceType', {
                                rules: [{required: true, message: '请选择设备类型'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">设备类型</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('create_name', {})}>
                            套&nbsp;&nbsp;餐&nbsp;&nbsp;名
                        </InputItem>
                        <InputItem type='digit' extra="元" {...getFieldProps('create_price', {
                            rules: [{required: true, message: '请填写会员价'}],
                        })}>
                            会&nbsp;&nbsp;员&nbsp;&nbsp;价
                        </InputItem>
                        <InputItem type='digit' extra="元" {...getFieldProps('create_fresherPrice', {
                        })}>
                            新用户价
                        </InputItem>
                        <InputItem type='number' extra="分钟" {...getFieldProps('create_gameMinutes', {
                            rules: [{required: true, message: '请填写游戏时间'}],
                        })}>
                            游戏时间
                        </InputItem>
                        <InputItem {...getFieldProps('create_description', {
                        })}>
                            描&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;述
                        </InputItem>
                        <InputItem {...getFieldProps('create_label', {
                        })}>
                            标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签
                        </InputItem>
                        <InputItem type='number' placeholder='值越大排序越靠前' {...getFieldProps('create_sortWeight', {
                        })}>
                            排序权重
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }


    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, selectedItem, deviceTypes } = this.state
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <Picker
                            cols={1}
                            data={deviceTypePickerData}
                            {...getFieldProps('update_deviceType', {
                                initialValue: selectedItem&&selectedItem.deviceType?[selectedItem.deviceType]:[],
                                rules: [{required: true, message: '请选择设备类型'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">设备类型</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('update_name', {
                            initialValue: selectedItem?(selectedItem.name?selectedItem.name:`${selectedItem.gameMinutes}分钟套餐`):null,
                        })}>
                            套&nbsp;&nbsp;餐&nbsp;&nbsp;名
                        </InputItem>
                        <InputItem type='digit' extra="元" {...getFieldProps('update_price', {
                            initialValue: selectedItem?selectedItem.price:null,
                            rules: [{required: true, message: '请填写会员价'}],
                        })}>
                            会&nbsp;&nbsp;员&nbsp;&nbsp;价
                        </InputItem>
                        <InputItem type='digit' extra="元" {...getFieldProps('update_fresherPrice', {
                            initialValue: selectedItem&&selectedItem.fresherPrice?selectedItem.fresherPrice:null,
                        })}>
                            新用户价
                        </InputItem>
                        <InputItem type='number' extra="分钟" {...getFieldProps('update_gameMinutes', {
                            initialValue: selectedItem?selectedItem.gameMinutes:null,
                            rules: [{required: true, message: '请填写游戏时间'}],
                        })}>
                            游戏时间
                        </InputItem>
                        <InputItem {...getFieldProps('update_description', {
                            initialValue: selectedItem?selectedItem.description:null,
                        })}>
                            描&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;述
                        </InputItem>
                        <InputItem {...getFieldProps('update_label', {
                            initialValue: selectedItem?selectedItem.label:null,
                        })}>
                            标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签
                        </InputItem>
                        <InputItem type='number' placeholder='值越大排序越靠前' {...getFieldProps('update_sortWeight', {
                            initialValue: selectedItem?selectedItem.sortWeight:null,
                        })}>
                            排序权重
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { sites, selectedSite, deviceType, deviceTypes } = this.state;
        const sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        return (
            <div className='wrapper-filter'>
                <div className='site-picker'>
                    <Picker 
                        cols={1}
                        value={[selectedSite]}
                        onOk={this.onSitePickerChange}
                        data={sitePickerData}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 门店</span>
                        </List.Item>
                    </Picker>
                </div>
                <div className='device-type-picker'>
                    <Picker
                        cols={1}
                        value={[deviceType?deviceType:'']}
                        onOk={this.onDeviceTypePickerChange}
                        data={[{label:'所有设备', value: ''}, ...deviceTypePickerData]}>
                        <List.Item></List.Item>
                    </Picker>
                </div>
            </div>
        )
    }

    render() {
        const { dataSource, isLoading, delegateProfile } = this.state;

        let rightContent
        if(!delegateProfile || delegateProfile.delegateType==='OPERATOR') {
            rightContent = <i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>
        } else {
            rightContent = <i/>
        }

        return (
            <div className='packet-page'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={rightContent}
                >
                    套餐设置
                </NavBar>
                {this.doRenderFilterView()}
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 122
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
            </div>
        )
    }
}

export default createForm()(PacketPage);


// WEBPACK FOOTER //
// ./src/components/PacketPage.js